import React from 'react';
import { Handle, Position } from '@xyflow/react';

const SetUserAttributeNode = ({ data, id, outputEdges, onEdgeCountChange, edgeLabels }) => {
  return (
    <div className="bg-white p-2 rounded-lg shadow-lg border-2 border-green-200 min-w-[200px]">
      <div className="p-3 py-5 bg-gradient-to-r from-green-50 to-green-100 border-b border-green-200 rounded-t-lg">
        <div className="flex items-center gap-2">
          <span className="text-xl">⚙️</span>
          <span className="font-semibold text-green-700">Set User Attribute</span>
        </div>
      </div>

      <Handle
        type="target"
        position={Position.Left}
        className="w-3 h-3 !bg-green-400 hover:!bg-green-500"
      />

      {Array.from({ length: outputEdges }).map((_, index) => (
        <>
          <Handle
            key={`output-${index}`}        
            type="source"
            position={Position.Right}
            id={`output-${index}`}
            className="w-3 h-3 !bg-green-400 hover:!bg-green-500"
            style={{ 
              top: `${((index + 1) * 100) / (outputEdges + 1)}%`
            }}
          />
        </>
      ))}
    </div>
  );
};

export default SetUserAttributeNode; 